import { useMemo, useState } from 'react';
import { Container, Row, Col, Card, CardBody, Input, InputGroup, InputGroupText } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Btn } from 'AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CategoryProgramContain from './CategoryProgramContain';
import { resetState } from 'Features/Learning/CategoryProgram/addCategoryProgramSlice';

const CategoryProgramContainer = () => {
  const dispatch = useDispatch();
  const cards = useSelector((state) => state.CategoryProgram.data.data);
  const [search, setSearch] = useState('');

  const handleAdd = () => {
    dispatch(resetState());
  };

  const filteredCards = useMemo(() => {
    if (!cards?.length) return cards;
    const query = search.trim().toLowerCase();
    if (!query) return cards;

    return cards.filter((item) => {
      const parentMatch = item?.name?.toLowerCase().includes(query) || String(item?.id).includes(query);
      const childMatch = item?.children?.some(
        (child) => child?.name?.toLowerCase().includes(query) || String(child?.id).includes(query)
      );
      return parentMatch || childMatch;
    });
  }, [cards, search]);

  const totalChildren = useMemo(
    () => (cards || []).reduce((sum, item) => sum + (item?.children?.length || 0), 0),
    [cards]
  );

  return (
    <Container fluid className="category-program">
      <Card className="category-program__toolbar mb-3">
        <CardBody className="py-3">
          <Row className="g-3 align-items-center">
            <Col lg="5" md="6">
              <div className="category-program__intro">
                <h5 className="mb-1">Kategori Program</h5>
                <p className="mb-0 text-muted">
                  Kelola kategori utama dan sub-kategori yang dipakai di aplikasi.
                </p>
              </div>
            </Col>
            <Col lg="3" md="6">
              {cards && (
                <div className="category-program__stats">
                  <span className="category-program__stat">
                    <strong>{cards.length}</strong> induk
                  </span>
                  <span className="category-program__stat">
                    <strong>{totalChildren}</strong> sub
                  </span>
                </div>
              )}
            </Col>
            <Col lg="4" md="12">
              <div className="category-program__actions">
                <InputGroup className="category-program__search">
                  <InputGroupText>
                    <i className="fa fa-search" aria-hidden="true" />
                  </InputGroupText>
                  <Input
                    type="search"
                    placeholder="Cari nama atau ID..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    aria-label="Cari kategori program"
                  />
                </InputGroup>
                <Link to={`${process.env.PUBLIC_URL}/category-program/add`} onClick={handleAdd}>
                  <Btn attrBtn={{ color: 'primary', className: 'category-program__add-btn' }}>
                    <i className="fa fa-plus me-1" aria-hidden="true" />
                    Tambah
                  </Btn>
                </Link>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Row className="learning-block">
        <Col xs="12">
          <CategoryProgramContain cardsOverride={filteredCards} searchQuery={search} />
        </Col>
      </Row>
    </Container>
  );
};

export default CategoryProgramContainer;
